export default {
      id: "oc-change-password-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-change-password",
      toString: function () {
        return this.url;
      }
    }